<div
  class="course-card bg-white rounded-lg overflow-hidden border border-gray-200 shadow-md h-full flex flex-col"
>
  <div class="course-image-container relative">
    <div
      class="course-badge-container absolute top-2 right-2 z-10 flex flex-row-reverse gap-2"
    ></div>
    <a [routerLink]="['/push-live', pushLive?.uuid]">
      <div class="aspect-w-16 aspect-h-9">
        <img
          [src]="pushLive?.thumb_path || 'assets/images/no-image.jpg'"
          [alt]="pushLive?.title"
          class="w-full h-full object-cover border-b border-gray-200"
          loading="lazy"
        />
      </div>
    </a>
  </div>

  <div class="course-detail-container p-4 flex-grow">
    <div class="course-detail-item title mb-3">
      <h3 class="text-lg font-semibold leading-tight">
        <a
          [routerLink]="['/push-live', pushLive?.uuid]"
          class="text-gray-800 hover:text-primary-600"
        >
          {{ pushLive?.title }}
        </a>
      </h3>
    </div>

    <div class="space-y-2">
      <div class="text-sm text-gray-600 flex items-start">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          />
        </svg>

        <span> <span class="font-medium">Code:</span> {{ pushLive?.code }} </span>
      </div>

      <div class="text-sm text-gray-600 flex items-start">
        <svg
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <span>
          <span class="font-medium">Release at:</span>
          {{ formatDate(pushLive?.release_date) }}
        </span>
      </div>
    </div>
  </div>

  <div class="course-footer-container p-2 bg-gray-50 border-t">
    <div class="course-detail-item access-button flex space-x-1">
      <ng-container *ngIf="(pushLive?.participations?.length ?? 0) > 0">
        <button
          *ngIf="pushLive?.participations?.[0]?.status !== 'certified'"
          (click)="startLive(pushLive?.uuid ?? '')"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Continue Activity
        </button>

        <a
          *ngIf="pushLive?.participations?.[0]?.status === 'certified'"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px] flex justify-center items-center"
        >
          Completed</a
        >

        <a
          [routerLink]="['/push-live', pushLive?.uuid]"
          class="font-semibold btn text-white px-1 py-2 rounded bg-primary-500 hover:bg-primary-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Activity Details
        </a>
      </ng-container>
      <a
        *ngIf="(pushLive?.participations?.length ?? 0) === 0"
        [routerLink]="['/push-live', pushLive?.uuid]"
        class="font-semibold btn text-white px-1 py-2 rounded bg-primary-500 hover:bg-primary-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
      >
        Activity Details
      </a>
    </div>
  </div>
</div>
